import React, { useEffect, useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  YAxis,
} from "recharts";

import DashboardPopOver from "../../../component/DashboardPopOver";
import { useSelector, useDispatch } from "react-redux";
import {
  addToMyDashboard,
  deleteWidgets,
} from "../../../redux/actions/analytics";

function AreaGraph({
  title,
  menu,
  data,
  id,
  isDisable,
  setUpdate,
  update,
  tab,
}) {
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState([]);

  // Redux
  const { color_palettes } = useSelector((state) => state.palettes);

  useEffect(() => {
    if (data) {
      setGraphData(data);
    }
  }, [data]);

  const chartPadding = { left: 20, right: 20 };

  const labelStyle = {
    fontSize: 8,
    fontWeight: 400,
    fill: "#535860", // Color of the label text
    lineHeight: "100%",
    textAlign: "center",
  };

  setTimeout(function () {
    const tickLines = document.querySelectorAll(
      ".recharts-cartesian-axis-tick-line"
    );

    tickLines.forEach((tickLine) => {
      tickLine.style.display = "none";
    });
  }, 10);

  // Add To My Dashboard
  const handleAddToMyDashboard = () => {
    const request = {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
      payload: {
        analytic_widget_id: id.analytic_widget_id,
      },
    };

    dispatch(addToMyDashboard(request));
  };

  // Delete Widget
  const handleDeleteWidgets = () => {
    const request = {
      dashboard_widget_id: id.analytic_dashboard_id,
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
    };

    dispatch(deleteWidgets(request));
  };

  return (
    <div className="h-full w-full">
      <div className="absolute top-1 right-2 text-base text-[#7D8490]">
        <DashboardPopOver
          menus={menu}
          handleOnClick={() =>
            tab ? handleDeleteWidgets() : handleAddToMyDashboard()
          }
          isDisable={isDisable}
        />
      </div>

      <div className="h-full w-full space-y-2">
        <h2 className="text-sm font-semibold text-[#313439] leading-5">
          {title}
        </h2>
        {graphData?.length > 0 ? (
          <div className="w-full h-[90%]">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={graphData}>
                <defs>
                  <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor={color_palettes[500]} stopOpacity={0.6} />
                    <stop offset="95%" stopColor={color_palettes[500]} stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis
                  dataKey="name"
                  tick={{ ...labelStyle }}
                  stroke="#D9D9D9"
                  padding={chartPadding}
                />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="total"
                  stroke={color_palettes[500]}
                  fillOpacity={1}
                  fill="url(#colorUv)"
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <div className="h-[90%] flex justify-center items-center text-sm font-semibold leading-5 capitalize">
            No Data Found
          </div>
        )}
      </div>
    </div>
  );
}

export default AreaGraph;
